import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { GLOBAL_STATE, QUESTION_ALL, QUESTION_TYPES, QUESTION_TYPES_COUNTS } from '../constants/actionTypes'

const selector = (state: RootState) => prop(GLOBAL_STATE, state)

export const questionAllSelector = createSelector(selector, data => data[QUESTION_ALL])

export const questionTypesSelector = createSelector(selector, data => data[QUESTION_TYPES])

export const questionTypesCountsSelector = createSelector(selector, data => data[QUESTION_TYPES_COUNTS])
